module.exports = "/_next/static/images/clock-f29efb5ed89c5cee834d77ff79317196.svg";